import { THEME_CONSTANTS } from '../1_settings/theme';

export const appSettingsMockBase = (jest: any): any => ({
	settings: {
		isEmbeddedInApp: false,
	},
	getEndpoint: jest.fn(),
	getSetting: jest.fn(),
	getTransition: jest.fn(),
	getBreakpoints: () => ({
		mobile: '',
		desktop: '',
		tablet: '',
	}),
	getPageTitle: jest.fn(),
	getMetaTitle: jest.fn(),
	getMetaDescription: jest.fn(),
	getMetaImage: jest.fn(),
	getMetaUrl: jest.fn(),
	getPlutoAssetsDir: () => '',
	useSSU: jest.fn(),
	getAuthRedirectUrl: jest.fn(),
	setState: jest.fn(),
	getEasing: jest.fn().mockReturnValue(THEME_CONSTANTS.easings.linear),
});
